import React, { useEffect, useState } from "react";
import { Alert, Spinner, Button } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { useLocation } from "react-router-dom";
import UlpsPortalApiClient from "../UlpsPortalApiClient";

export default function Features() {
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [successMessage, setSuccessMessage] = useState("");

  const location = useLocation();

  // Create success (?success=true)
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.get("success") === "true") {
      setSuccessMessage("Feature created successfully.");

      const timer = setTimeout(() => {
        setSuccessMessage("");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [location.search]);

  // Load features
  useEffect(() => {
    setLoading(true);

    UlpsPortalApiClient.getFeatures()
      .then((data) => {
        setFeatures(data);
      })
      .catch((e) => {
        console.error(e);
        setError("Failed to load features.");
      })
      .finally(() => setLoading(false));
  }, []);

  const handleDelete = (featureId) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this feature?"
    );

    if (!confirmed) return;

    UlpsPortalApiClient.deleteFeature(featureId)
      .then(() => {
        setFeatures((prev) => prev.filter((f) => f.id !== featureId));

        setSuccessMessage("Feature deleted successfully.");
        setTimeout(() => setSuccessMessage(""), 4000);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to delete feature.");
      });
  };

  const columns = [
    {
      dataField: "id",
      text: "ID",
      headerStyle: { width: "80px" },
      sort: true,
    },
    {
      dataField: "name",
      text: "Feature Name",
      sort: true,
      style: {
        maxWidth: '100px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    },
    {
      dataField: "description",
      text: "Description",
      style: {
        maxWidth: '100px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
       
    },
    {
      dataField: "licenceSchemas",
      text: "Products",
      formatter: (_, row) =>
        row.licenceSchemas && row.licenceSchemas.length > 0
          ? row.licenceSchemas.join(", ")
          : "None",
    },
    {
      dataField: "actions",
      text: "",
      headerStyle: { width: "60px" },
      formatter: (_, row) => (
        <Button
          variant="danger"
          size="sm"
          onClick={() => handleDelete(row.id)}
        >
          X
        </Button>
      ),
    },
  ];

  return (
    <>
      <h2>ULPS Features</h2>

      {successMessage && (
        <Alert
          variant="success"
          dismissible
          onClose={() => setSuccessMessage("")}
        >
          {successMessage}
        </Alert>
      )}

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError("")}>
          {error}
        </Alert>
      )}

      <Button
        className="mb-3"
        variant="success"
        href="#/feature/create"
      >
        Add Feature
      </Button>

      {loading ? (
        <div className="d-flex justify-content-center mb-3">
          <Spinner animation="border" />
        </div>
      ) : (
        <BootstrapTable
          keyField="id"
          data={features}
          columns={columns}
          striped
          hover
          condensed
          noDataIndication="No features found"
        />
      )}
    </>
  );
}
